import { Table } from "melco-ui";
import { useTranslation } from "react-i18next";
// import { CancelDrawer } from "./drawer/Cancel/CancelDrawer";
import { useUserLogFiles } from "../../../hooks/users/useUserLogFiles";
import { LogFilesDownloadActionButton } from "../LogFilesDownloadActionButton";
import {TrackingMelcoModelsLogListItem} from "melco-shared-logic";

type UserLogFilesPropTypes = {
  userId: string;
  productCode: string;
};

export const UserLogFilesList: React.FC<UserLogFilesPropTypes> = ({
  userId,
  productCode,
}) => {
  const {
    isLoading,
    isFetching,
    data,
    isPreviousData,
    errorComponent,
    onTableConfigChange,

    refetch,
  } = useUserLogFiles(userId, productCode);

  const { t } = useTranslation();

  const callBackFn = () => {
    refetch();
    // Made just in future if we need it to refresh data
  };

  const columns = [
    {
      title: t("users.tabs.logfiles.table.columns.file_name"),
      key: "file_name",
      dataIndex: "file_name",
      // sorter: true,
      width: 30,
    },
    {
      title: t("users.tabs.logfiles.table.columns.device_name"),
      key: "device_name",
      dataIndex: "device_name",
      // sorter: true,
      width: 30,
    },
    {
      title: t("users.tabs.logfiles.table.columns.category"),
      key: "category",
      dataIndex: "category",
      // sorter: true,
      width: 30,
    },
    {
      title: t("users.tabs.logfiles.table.columns.description"),
      key: "description",
      dataIndex: "description",
      // sorter: true,
      width: 30,
    },
    {
      title: t("users.tabs.logfiles.table.columns.created_on"),
      key: "created_on",
      //dataIndex: "subscription_code",
      //  sorter: true,
      width: 30,
      render: (rowObj: TrackingMelcoModelsLogListItem) => {
        return (
          <>
            {rowObj.created_on
              ? new Date(rowObj.created_on).toLocaleString()
              : ""}
          </>
        );
      },
    },

    {
      title: t("users.tabs.logfiles.table.columns.actions"),
      key: "actions",
      //dataIndex: "",
      // sorter: true,
      width: 30,
      render: (rowObj: TrackingMelcoModelsLogListItem) => (
        <>
          <LogFilesDownloadActionButton
            fileNameToSaveDownload={rowObj?.file_name ?? "LogFile.zip"}
            logFileIdToDownload={rowObj?.id ? rowObj.id.toString() : ""}
            userIdToDownloadLogFiles={userId}
            callBackFn={callBackFn}
          />
        </>
      ),
    },
  ];

  return (
    <>
      <div>
        <Table
          // showSorterTooltip={false}
          sticky
          loading={isPreviousData ? isFetching : isLoading}
          dataSource={data}
          columns={columns}
          onChange={onTableConfigChange}
          pagination={false}
          noDataMessage={t("users.tabs.logfiles.table.no_data_message")}
          errorComponent={errorComponent}
          //scroll={{ x: 1700 }}
        />
      </div>
    </>
  );
};
